module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-content admin-content"
  }, [(_vm.patientLoading) ? _c('div', {
    staticClass: "loading"
  }, [_c('md-progress', {
    attrs: {
      "md-indeterminate": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("Cargando mapa de Pacientes para la comuna seleccionada...")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "main-content"
  }, [_c('div', {
    staticClass: "table-results display-flex justify-content-between align-items-start"
  }, [_c('div', {
    staticClass: "title-results"
  }, [_c('h3', [_vm._v("Resultados de Pacientes\n            "), _c('span', {
    staticClass: "bubble"
  }, [_vm._v(_vm._s(_vm.patientsWithCoords.length + _vm.patientsWithoutCoords))])])])]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-info",
    staticStyle: {
      "background": "#39b7c0",
      "color": "white",
      "padding": "10px",
      "margin-bottom": "20px"
    }
  }, [_vm._v("Con el fin de proteger la privacidad de nuestros Pacientes no mostramos la identidad de ellos ni su ubicación exacta, la ubicación es modificada de manera al azar en un radio de 2km de la registrada en nuestros sistemas.")]), _vm._v(" "), _c('div', {
    staticClass: "map-results"
  }, [(_vm.mapLoading) ? _c('div', {
    staticClass: "map-loading"
  }, [_c('div', {
    staticClass: "loading-content"
  }, [_c('md-spinner', {
    staticClass: "md-accent",
    staticStyle: {
      "width": "40px",
      "height": "40px"
    },
    attrs: {
      "md-indeterminate": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("Cargando mapa y ubicaciones...")]), _vm._v(" "), _c('p', {
    staticClass: "loading-detail"
  }, [_vm._v("Procesando " + _vm._s(_vm.companiesWithCoords.length) + " empresas y " + _vm._s(_vm.patientsWithCoords.length) + " pacientes con ubicación")])], 1)]) : (_vm.mapReady) ? _c('div', {
    staticClass: "map-ready-indicator"
  }, [_c('div', {
    staticClass: "ready-content"
  }, [_c('md-icon', {
    staticClass: "ready-icon"
  }, [_vm._v("check_circle")]), _vm._v(" "), _c('p', [_vm._v("Mapa listo para usar")]), _vm._v(" "), _c('p', {
    staticClass: "ready-detail"
  }, [_vm._v(_vm._s(_vm.patientsWithCoords.length) + " pacientes cargados")])], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "map-controls"
  }, [_c('md-button', {
    staticClass: "md-icon-button fullscreen-btn",
    on: {
      "click": _vm.openFullscreenMap
    }
  }, [_c('md-icon', [_vm._v("fullscreen")])], 1)], 1), _vm._v(" "), _c('div', {
    ref: "mapContainer",
    staticStyle: {
      "height": "500px",
      "width": "100%",
      "border": "1px solid #ddd",
      "border-radius": "4px"
    },
    attrs: {
      "id": "map-container"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "map-info"
  }, [_c('p', [_c('strong', [_vm._v("Pacientes con ubicación:")]), _vm._v(" " + _vm._s(_vm.patientsWithCoords.length) + " (" + _vm._s(_vm.patientsWithoutCoords) + " sin coordenadas)")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Pacientes totales en comuna:")]), _vm._v(" " + _vm._s(_vm.patientsWithCoords.length + _vm.patientsWithoutCoords))]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Estado:")]), _vm._v(" "), (_vm.mapLoading) ? _c('span', {
    staticStyle: {
      "color": "#ff9800"
    }
  }, [_vm._v("Cargando...")]) : (_vm.mapReady) ? _c('span', {
    staticStyle: {
      "color": "#4caf50"
    }
  }, [_vm._v("Listo")]) : _c('span', {
    staticStyle: {
      "color": "#f44336"
    }
  }, [_vm._v("No inicializado")])]), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: "table-filters",
    staticStyle: {
      "padding": "20px",
      "background": "#fafafa"
    }
  }, [_c('b', [_vm._v(" Calcule su alcance estimado, unicamente puede seleccionar comunas donde ud cuenta con una consulta / BOX : ")]), _vm._v(" "), (this.datatable.filters.comunities.length == 0) ? _c('div', {
    staticStyle: {
      "padding": "20px",
      "background": "#dac50b6e"
    }
  }, [_vm._v("Usted no cuenta con consultas / BOX ")]) : _vm._e(), _vm._v(" "), (_vm.datatable.filters.comunities.length) ? _c('md-input-container', {
    staticClass: "select-border filter-item"
  }, [_c('label', [_vm._v("Comuna")]), _vm._v(" "), _c('md-select', {
    attrs: {
      "placeholder": "Comuna"
    },
    model: {
      value: (_vm.datatable.filters.options.comunity_filter),
      callback: function($$v) {
        _vm.datatable.filters.options.comunity_filter = $$v
      },
      expression: "datatable.filters.options.comunity_filter"
    }
  }, _vm._l((_vm.datatable.filters.comunities), function(row, rowIndex) {
    return _c('md-option', {
      key: rowIndex,
      attrs: {
        "value": row.id
      }
    }, [_vm._v("\n              " + _vm._s(row.name) + "\n            ")])
  }))], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "total-stats"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-stats"
  }, [_c('div', {
    staticClass: "stat-item"
  }, [_c('h4', [_vm._v("Alcance")]), _vm._v(" "), _c('h3', {
    staticClass: "stat-price"
  }, [_c('span', {
    staticClass: "sign"
  }), _vm._v(_vm._s(this.datatable.filters.pages.total ? _vm.patientsWithCoords.length + _vm.patientsWithoutCoords : "Seleccione una comuna") + "\n                "), _c('div', {
    staticClass: "type"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-stats"
  }, [_c('div', {
    staticClass: "stat-item"
  }, [_c('h4', [_vm._v("Efectividad estimada")]), _vm._v(" "), _c('h3', {
    staticClass: "stat-price"
  }, [_c('span', {
    staticClass: "sign"
  }), _vm._v(_vm._s(this.datatable.filters.pages.total ? _vm.rounded((_vm.patientsWithCoords.length + _vm.patientsWithoutCoords) * 0.82) : "Seleccione una comuna") + "\n                "), _c('div', {
    staticClass: "type"
  })])])])])]), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised md-primary",
    on: {
      "click": function($event) {
        _vm.soon()
      }
    }
  }, [_vm._v("Promocionar")])], 1), _vm._v(" "), _c('md-snackbar', {
    ref: "snackbar",
    attrs: {
      "md-position": "bottom center",
      "md-duration": "8000"
    }
  }, [_c('span', [_vm._v("Hemos comenzado tu proceso de aprobación para publicar, Recibiras un correo una vez haya concluido el proceso.")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-accent",
    attrs: {
      "md-theme": "light-blue"
    },
    on: {
      "click": function($event) {
        _vm.$refs.snackbar.close()
      }
    }
  }, [_vm._v("OK")])], 1), _vm._v(" "), _c('md-dialog', {
    ref: "dialog1",
    staticStyle: {
      "z-index": "10010"
    },
    attrs: {
      "md-open-from": "#custom",
      "md-close-to": "#custom"
    }
  }, [_c('form', {
    attrs: {
      "novalidate": ""
    }
  }, [_c('md-dialog-content', [_c('b', [_vm._v("Vista Previa")]), _vm._v(" "), _c('md-button-toggle', {
    attrs: {
      "md-single": ""
    }
  }, [_c('md-button', {
    on: {
      "click": function($event) {
        _vm.preview(1)
      }
    }
  }, [_vm._v("Correo Electronico")]), _vm._v(" "), _c('md-button', {
    on: {
      "click": function($event) {
        _vm.preview(2)
      }
    }
  }, [_vm._v("WhatsApp")]), _vm._v(" "), _c('md-button', {
    on: {
      "click": function($event) {
        _vm.preview(3)
      }
    }
  }, [_vm._v("Notificación Push")])], 1), _vm._v(" "), (_vm.preview_item == 1) ? _c('div', {
    staticClass: "col-md-12 col-sm-12 col-xs-12 no-padder"
  }, [_c('br'), _vm._v(" "), _c('b', [_vm._v("Seleccione una opción")]), _vm._v(" "), _c('div', [_c('md-radio', {
    attrs: {
      "md-value": "default"
    },
    model: {
      value: (_vm.typeEmail),
      callback: function($$v) {
        _vm.typeEmail = $$v
      },
      expression: "typeEmail"
    }
  }, [_c('strong', [_vm._v("\n            Enviar correo predeterminado\n          ")])]), _vm._v(" "), _c('md-radio', {
    attrs: {
      "md-value": "person"
    },
    model: {
      value: (_vm.typeEmail),
      callback: function($$v) {
        _vm.typeEmail = $$v
      },
      expression: "typeEmail"
    }
  }, [_c('strong', [_vm._v("\n            Enviar correo personalizado\n          ")])])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "0"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('div', {
    staticClass: "sc-iRbamj hQVZHze"
  }, [(_vm.typeEmail === 'person') ? _c('div', {
    staticStyle: {
      "padding": "0"
    }
  }, [_c('br'), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-input-container', [_c('label', [_vm._v("Correo")]), _vm._v(" "), _c('md-field', [_c('md-input', {
    model: {
      value: (_vm.form.to),
      callback: function($$v) {
        _vm.form.to = $$v
      },
      expression: "form.to"
    }
  })], 1)], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("Mensaje")]), _vm._v(" "), _c('md-field', [_c('md-textarea', {
    model: {
      value: (_vm.form.text),
      callback: function($$v) {
        _vm.form.text = $$v
      },
      expression: "form.text"
    }
  })], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('md-input-container', [_c('md-field', [_c('label', [_vm._v("Ingresar una imagen")]), _vm._v(" "), _c('md-file', {
    model: {
      value: (_vm.form.image),
      callback: function($$v) {
        _vm.form.image = $$v
      },
      expression: "form.image"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('br')], 1) : _vm._e(), _vm._v(" "), (_vm.typeEmail === 'default') ? _c('div', {
    staticClass: "sc-jlyJG jiSlDO"
  }, [_c('span', {
    staticClass: "sc-csuQGl ezfjWK",
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.the_doctor.specialities[0].name) + "\n              " + _vm._s(_vm.the_doctor.name + " " + (_vm.the_doctor.lastname ? _vm.the_doctor.lastname : _vm.the_doctor.lastname2)) + "\n            ")])]) : _vm._e(), _vm._v(" "), (_vm.typeEmail === 'default') ? _c('div', {
    staticClass: "sc-gipzik eLaYeg"
  }, [_c('div', {
    staticClass: "sc-hzDkRC jHeljQ"
  }, [_c('div', {
    staticClass: "sc-jhAzac cypPtq"
  }, [_c('div', {
    staticClass: "sc-fBuWsC jLtcjp"
  }, [_vm._v("\n                  Prestador Destacado\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "sc-fMiknA enniBG"
  }, [_vm._v("\n                  Te invitamos a conocer a nuestro Prestador de Salud en convenio con ColaboraMed\n                  atención preferencial con bonificación hasta del 80% del Co-Pago, para pago online.\n                ")])])])]) : _vm._e()])])], 1)]) : _vm._e(), _vm._v(" "), (_vm.preview_item == 2) ? _c('div', {
    staticClass: "desktop_only",
    staticStyle: {
      "height": "450px",
      "overflow": "hidden",
      "text-align": "center"
    }
  }, [_c('div', {
    staticClass: "marvel-device iphone-x",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('div', {
    staticClass: "notch"
  }, [_c('div', {
    staticClass: "camera"
  }), _vm._v(" "), _c('div', {
    staticClass: "speaker"
  })]), _vm._v(" "), _c('div', {
    staticClass: "top-bar"
  }), _vm._v(" "), _c('div', {
    staticClass: "sleep"
  }), _vm._v(" "), _c('div', {
    staticClass: "bottom-bar"
  }), _vm._v(" "), _c('div', {
    staticClass: "volume"
  }), _vm._v(" "), _c('div', {
    staticClass: "overflow"
  }, [_c('div', {
    staticClass: "shadow shadow--tr"
  }), _vm._v(" "), _c('div', {
    staticClass: "shadow shadow--tl"
  }), _vm._v(" "), _c('div', {
    staticClass: "shadow shadow--br"
  }), _vm._v(" "), _c('div', {
    staticClass: "shadow shadow--bl"
  })]), _vm._v(" "), _c('div', {
    staticClass: "inner-shadow"
  }), _vm._v(" "), _c('div', {
    staticClass: "screen"
  }, [_c('div', {
    staticClass: "screen-container"
  }, [_c('div', {
    staticClass: "status-bar"
  }, [_c('div', {
    staticClass: "time"
  }), _vm._v(" "), _c('div', {
    staticClass: "battery"
  }, [_c('i', {
    staticClass: "zmdi zmdi-battery"
  })]), _vm._v(" "), _c('div', {
    staticClass: "network"
  }, [_c('i', {
    staticClass: "zmdi zmdi-network"
  })]), _vm._v(" "), _c('div', {
    staticClass: "wifi"
  }, [_c('i', {
    staticClass: "zmdi zmdi-wifi-alt-2"
  })]), _vm._v(" "), _c('div', {
    staticClass: "star"
  }, [_c('i', {
    staticClass: "zmdi zmdi-star"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "chat"
  }, [_c('div', {
    staticClass: "chat-container"
  }, [_c('div', {
    staticClass: "user-bar"
  }, [_c('div', {
    staticClass: "back"
  }, [_c('i', {
    staticClass: "zmdi zmdi-arrow-left"
  })]), _vm._v(" "), _c('div', {
    staticClass: "avatar"
  }, [_c('img', {
    attrs: {
      "src": "https://avatars2.githubusercontent.com/u/398893?s=128",
      "alt": "Avatar"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_c('span', [_vm._v("Paciente")]), _vm._v(" "), _c('span', {
    staticClass: "status"
  }, [_vm._v("en linea")])]), _vm._v(" "), _c('div', {
    staticClass: "actions more"
  }, [_c('i', {
    staticClass: "zmdi zmdi-more-vert"
  })]), _vm._v(" "), _c('div', {
    staticClass: "actions attachment"
  }, [_c('i', {
    staticClass: "zmdi zmdi-attachment-alt"
  })]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('i', {
    staticClass: "zmdi zmdi-phone"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "conversation"
  }, [_c('div', {
    staticClass: "conversation-container"
  }, [_c('div', {
    staticClass: "message sent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "18px",
      "line-height": "21px"
    }
  }, [_vm._v("Te invitamos a conocer a nuestro Prestador de Salud "), _c('b', [_vm._v(_vm._s(_vm.the_doctor.name + " " + (_vm.the_doctor.lastname ? _vm.the_doctor.lastname : "")))]), _vm._v(" especialista en "), _c('b', _vm._l((_vm.the_doctor.specialities), function(row, rowIndex) {
    return _c('font', {
      key: rowIndex
    }, [_vm._v(_vm._s(row.name) + _vm._s(_vm.the_doctor.specialities.length > (rowIndex + 1) ? ", " : ""))])
  })), _vm._v(" para agendar con el puedes presionar el siguiente botón:\n\n      "), _c('a', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "color": "blue",
      "text-decoration": "none",
      "display": "block",
      "margin-top": "20px"
    },
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("Agendar con "), _c('b', [_vm._v("\n      " + _vm._s(_vm.the_doctor.name + " " + (_vm.the_doctor.lastname ? _vm.the_doctor.lastname : "")))])])]), _vm._v(" "), _c('span', {
    staticClass: "metadata"
  }, [_c('span', {
    staticClass: "time"
  }), _c('span', {
    staticClass: "tick"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "15",
      "id": "msg-dblcheck-ack",
      "x": "2063",
      "y": "2076"
    }
  }, [_c('path', {
    attrs: {
      "d": "M15.01 3.316l-.478-.372a.365.365 0 0 0-.51.063L8.666 9.88a.32.32 0 0 1-.484.032l-.358-.325a.32.32 0 0 0-.484.032l-.378.48a.418.418 0 0 0 .036.54l1.32 1.267a.32.32 0 0 0 .484-.034l6.272-8.048a.366.366 0 0 0-.064-.512zm-4.1 0l-.478-.372a.365.365 0 0 0-.51.063L4.566 9.88a.32.32 0 0 1-.484.032L1.892 7.77a.366.366 0 0 0-.516.005l-.423.433a.364.364 0 0 0 .006.514l3.255 3.185a.32.32 0 0 0 .484-.033l6.272-8.048a.365.365 0 0 0-.063-.51z",
      "fill": "#4fc3f7"
    }
  })])])])])]), _vm._v(" "), _c('form', {
    staticClass: "conversation-compose"
  }, [_c('div', {
    staticClass: "emoji"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "id": "smiley",
      "x": "3147",
      "y": "3209"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M9.153 11.603c.795 0 1.44-.88 1.44-1.962s-.645-1.96-1.44-1.96c-.795 0-1.44.88-1.44 1.96s.645 1.965 1.44 1.965zM5.95 12.965c-.027-.307-.132 5.218 6.062 5.55 6.066-.25 6.066-5.55 6.066-5.55-6.078 1.416-12.13 0-12.13 0zm11.362 1.108s-.67 1.96-5.05 1.96c-3.506 0-5.39-1.165-5.608-1.96 0 0 5.912 1.055 10.658 0zM11.804 1.01C5.61 1.01.978 6.034.978 12.23s4.826 10.76 11.02 10.76S23.02 18.424 23.02 12.23c0-6.197-5.02-11.22-11.216-11.22zM12 21.355c-5.273 0-9.38-3.886-9.38-9.16 0-5.272 3.94-9.547 9.214-9.547a9.548 9.548 0 0 1 9.548 9.548c0 5.272-4.11 9.16-9.382 9.16zm3.108-9.75c.795 0 1.44-.88 1.44-1.963s-.645-1.96-1.44-1.96c-.795 0-1.44.878-1.44 1.96s.645 1.963 1.44 1.963z",
      "fill": "#7d8489"
    }
  })])]), _vm._v(" "), _c('input', {
    staticClass: "input-msg",
    attrs: {
      "name": "input",
      "placeholder": "Type a message",
      "autocomplete": "off",
      "autofocus": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "photo"
  }, [_c('i', {
    staticClass: "zmdi zmdi-camera"
  })]), _vm._v(" "), _c('button', {
    staticClass: "send"
  }, [_c('div', {
    staticClass: "circle"
  }, [_c('i', {
    staticClass: "zmdi zmdi-mail-send"
  })])])])])])])])])])]) : _vm._e(), _vm._v(" "), (_vm.preview_item == 3) ? _c('div', {
    staticClass: "desktop_only",
    staticStyle: {
      "height": "450px",
      "overflow": "hidden"
    }
  }, [_c('div', {
    staticClass: "sc-jDwBTQ egkRpC",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('div', {
    staticClass: "sc-gPEVay dSmbrN"
  }, [_c('div', {
    staticClass: "sc-iRbamj hQVZHz"
  }, [_c('div', {
    staticClass: "sc-jlyJG jiSlDO"
  }, [_c('span', {
    staticClass: "sc-csuQGl ezfjWK",
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("AMOL")]), _c('span', {
    staticClass: "sc-Rmtcm deQnlS"
  }, [_vm._v("now")])]), _vm._v(" "), _c('div', {
    staticClass: "sc-gipzik eLaYeg"
  }, [_c('div', {
    staticClass: "sc-hzDkRC jHeljQ"
  }, [_c('div', {
    staticClass: "sc-jhAzac cypPtq"
  }, [_c('div', {
    staticClass: "sc-fBuWsC jLtcjp"
  }, [_vm._v("\n                  Prestador Destacado\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "sc-fMiknA enniBG"
  }, [_vm._v("\n                  Te invitamos a conocer a nuestro Prestador de Salud\n                  " + _vm._s(_vm.the_doctor.name + " " + (_vm.the_doctor.lastname ? _vm.the_doctor.lastname : "")) + " especialista en\n                  "), _vm._l((_vm.the_doctor.specialities), function(row, rowIndex) {
    return _c('font', {
      key: rowIndex
    }, [_vm._v("\n                    " + _vm._s(row.name) + _vm._s(_vm.the_doctor.specialities.length > (rowIndex + 1) ? ", " : "") + "\n                  ")])
  })], 2)])])])]), _vm._v(" "), _c('div', {
    staticClass: "sc-fAjcbJ dgBCNv"
  }, [_c('div', {
    staticClass: "sc-caSCKo bFdPyK"
  }, [_vm._v("Agendar Hora")])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "movil_only"
  }, [_c('div', {
    staticStyle: {
      "padding": "20px",
      "background": "#dac50b6e"
    }
  }, [_vm._v("No puedes visualizar las vistas previas en un dispositivo movil debido a que para generar una vista previa fidedigna se utiliza la misma resolucion y proporcion que un dispositivo movil. ")])])], 1), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
    staticClass: "md-primary btn--cancel",
    nativeOn: {
      "click": function($event) {
        _vm.closeDialog('dialog1')
      }
    }
  }, [_vm._v("Cerrar")]), _vm._v(" "), (_vm.preview_item == 1) ? _c('md-button', {
    staticClass: "md-primary btn--save btn--blue",
    nativeOn: {
      "click": function($event) {
        _vm.sendEmail()
      }
    }
  }, [_vm._v("\n            Enviar\n          ")]) : _vm._e(), _vm._v(" "), (_vm.preview_item > 1) ? _c('md-button', {
    staticClass: "md-primary btn--save btn--blue",
    nativeOn: {
      "click": function($event) {
        _vm.soon2()
      }
    }
  }, [_vm._v("\n            Publicar\n          ")]) : _vm._e()], 1)], 1)]), _vm._v(" "), _c('md-dialog', {
    ref: "fullscreenMap",
    staticClass: "fullscreen-map-modal",
    staticStyle: {
      "width": "100vw",
      "height": "100vh",
      "max-width": "100%",
      "max-height": "100%"
    }
  }, [_c('md-dialog-title', {
    staticStyle: {
      "position": "fixed",
      "top": "0",
      "left": "0",
      "right": "0",
      "background": "white",
      "z-index": "10000",
      "padding": "16px 24px",
      "border-bottom": "1px solid #ddd",
      "display": "flex",
      "justify-content": "space-between",
      "align-items": "center"
    }
  }, [_c('span', [_vm._v("Mapa de Empresas - Vista Completa")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-icon-button md-dense",
    on: {
      "click": _vm.closeFullscreenMap
    }
  }, [_c('md-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('md-dialog-content', {
    staticStyle: {
      "padding": "0",
      "margin": "0",
      "width": "100%",
      "height": "100%"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "id": "fullscreen-map-container"
    }
  })])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("Nota:")]), _vm._v(" Los marcadores se agrupan automáticamente para mejor rendimiento")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6b91fea8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/doctor/PatientCoords.vue
// module id = 687
// module chunks = 1